import {  useEffect, useState } from "react";
import { Card, CardBody } from "../components/card/card";
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import icons from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import CardDashComponent from "../components/card/CardDashComponent";
import { useDispatch, useSelector } from "react-redux";
import ConvertImage from "../components/content/convertImage";
import { getSitesList, getSitesPage } from "../redux/action/sitesAction";
import { useLocation } from "react-router-dom";
import { getRoleModuleById } from "../redux/action/roleModuleAction";
import findItem from "../helperFindPath";

let DefaultIcon = L.icon({
  iconUrl: icons,
  shadowUrl: iconShadow,
})
const Lokasi = () => {
  const { dataSitesList } = useSelector((state) => state.sites );
  // console.log(dataSitesList)
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const param = {
    token: user.access_token,
  }
  useEffect(() => {
    dispatch(getSitesList(param));
  }, []);
  const position = [-6.224248942482978,106.80601255573566]
  // const Markers = [
  //   { text: "JPO Gelora Bung Karno", position: [-6.224248942482978, 106.80601255573566], image: '/assets/img/jpo/Gelora Bung Karno.jpg' },
  //   { text: "JPO Bundaran Senayan", position: [-6.227286349845367, 106.80151282875084], image: '/assets/img/jpo/Senayan.jpeg' },
  //   { text: "JPO Polda Jakarta Raya", position: [-6.221292580775737, 106.8096439929374] , image: '/assets/img/jpo/Polda.jpeg'},
  // ];
  const {dataRoleModuleSidebar, dataByIdRoleModule} = useSelector((state)=>state.roleModule)
  const { pathname } = useLocation();
  const [ dataObjPath, setDataObjPath] = useState('')
  useEffect(() => {
    if(dataObjPath !== ''){
      param.id = dataObjPath.id
      dispatch(getRoleModuleById(param))
    }
    // eslint-disable-next-line
  }, [dataObjPath]);
  useEffect(()=>{
    if(dataRoleModuleSidebar.length > 0){
      const findPath = findItem(dataRoleModuleSidebar, pathname)
      if(findPath !== null){
        setDataObjPath(findPath) 
      }
    }
  },[dataRoleModuleSidebar])

  if(dataByIdRoleModule !== ''){

    if(!dataByIdRoleModule.create && !dataByIdRoleModule.read && !dataByIdRoleModule.update && !dataByIdRoleModule.delete){
      return (
        <div>
          <h2>403: Forbidden</h2>
          <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
        </div>
      )
    }else{
	
  return (
    <div className="container">
			<div className="row justify-content-center">
				<div className="col-xl-12">
					<div className="row">
						<div className="col-xl-12">
							<Card>
                <CardBody>
                  <MapContainer
                    center={position}
                    // scrollWheelZoom={false}
                    zoom={13}
                    style={{ height: 500, width: '100%' }}
                  >
                     <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                     />
                        {dataSitesList.map((key, index) =>
                            key.siteLat && key.siteLon ? (
                           <Marker key={index} position={[key.siteLat, key.siteLon]} icon={DefaultIcon}>
                           <Popup>
                                  <ConvertImage imageString={key.image} /> 
                                  {key.siteName} 
                            </Popup>
                          </Marker>
                        ) : null,
                      )}
                  </MapContainer>
								</CardBody>
							</Card>
						</div>
					</div>
				</div>
			</div>
		</div>
  );


  }
  }
    return (
    <div>
      <h2>403: Forbidden</h2>
      <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
    </div>
  )
};

export default Lokasi;
